import { Component, OnInit, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/pages/common/api.service';
import { GlobalConstants } from 'src/app/pages/common/global-variables';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { DataTransferService } from 'src/app/shared/services/common/datatransfer.service';

@Component({
  selector: 'app-offer-listing',
  templateUrl: './offer-listing.component.html',
  styleUrls: ['./offer-listing.component.scss'],
  providers: [ApiService, GlobalConstants]
})
export class OfferListingComponent implements OnInit {
  reloadSubscription: Subscription;
  isSearchDropdownOpen: any = false;
  selectedCat: any = '';
  categoryCode: any;
  categories: any = [];
  offerCategory: any;
  selectedCategories: any = [];
  offersubcategories: any = [];
  offers: any = [];
  offersForCount: any = [];

  merchantList: any = [];
  categoryWithOffer: any = [];
  showNull: any;
  scrolled: any = true;
  selectedCatId: any = -1;
  searchInput: string = '';
  hideHeader: boolean = false;
  authenticated_user = false;
  ngOnDestroy() {
    if(this.reloadSubscription){
      this.reloadSubscription.unsubscribe()
    }
    this.elementRef.nativeElement.remove();
  }
  removeSubscriptions(){
    if(this.reloadSubscription){
      this.reloadSubscription.unsubscribe()
    }
  }
  constructor(
    private route: ActivatedRoute,
    private _apiService: ApiService,
    private http: HttpClient,
    private location: Location,
    public GlobalConstants: GlobalConstants,
    public meta: Meta,
    public pageTitle: Title,
    private dataTransferService: DataTransferService,
    private elementRef: ElementRef
    ) {}
  backClicked() {
    this.location.back();
  }
  ngOnInit() {
    this.checkAuth()
    setTimeout(() => {    //<<<---    using ()=> syntax
      document.getElementById('top-section').scrollIntoView({ block: 'start' });
    }, 400);

    this.pageTitle.setTitle(this.GlobalConstants.data.titles.homepage_pagetitle);
    this.meta.addTags([
      { name: 'description', content: this.GlobalConstants.data.titles.homepage_description },
      { name: 'keywords', content: this.GlobalConstants.data.titles.homepage_keywords }
    ]);
    this.getAllCategories()
    // this.removeSubscriptions();
    if(!this.reloadSubscription){
      this.reloadSubscription = this.dataTransferService.sharedReloadEvent.subscribe(res => {
        if(res){
          console.log('reload')
          this.checkAuth();
          this.getAllCategories();
        }
      });
    }

  }
  checkAuth(){
    if (localStorage.getItem("currentUser")) {
      this.authenticated_user = true;
    }
  }
  redeemOffer(merchant){

  }
  getCategoryDetail(id) {
    var params = { benefit_type: 'offers' }
    // params.sub_category = true;
    this._apiService.getCategoryDetail(id, params).subscribe(
      (res: any) => {
        this.offerCategory = res.data;
      },
      (err) => {
      }
    );
  }

  //categories
  categoriesRes: any;
  allCatAndSubCat: any;
  filteredCategories: any;
  offerCategories= [];


  selectedCategory: any;
  selectedSubCategory: any;
  getAllCategories() {
      this._apiService.getCategories([]).subscribe(
        (res: any) => {
          this.categoriesRes = res.data.filter((item) => item.attributes.code != 'all');
          this.allCatAndSubCat = [...this.categoriesRes.map((item) => item = item.attributes)];
          this.filteredCategories = this.categoriesRes.filter(x => x.parent_id == null)
          this.filteredCategories.forEach(category => {
            category.subCategories = this.categoriesRes.filter(x => x.parent_id == category.id)
            if (category.attributes.sub_categories) {
              this.allCatAndSubCat.push(...category.attributes.sub_categories);
            }
          });
          this.categories = this.filteredCategories;
          this.getCategories();
        },
        () => {
        }
      );

  }
  allSubcategory: any;
  mainCategories: any = [];
  selectedSubCategoryIndex: number;
  getCategories() {
    this.is_loading = true;
    this.offerCategories = [...this.offerCategories, ...this.categories];
    this.allSubcategory = [];
    this.categories.forEach(x => {
      x.attributes.sub_categories.forEach(y => {
        y.category = x;
        this.allSubcategory.push(y);
      })
    });
    this.route.params.forEach(params => {
      if (params.category) {
        let categoryIndex = this.getIndexOfK(this.offerCategories, params.category, 'code');
        this.selectedCategory = this.offerCategories[categoryIndex];
        if (params.sub_category && this.offerCategories.length > 0) {

          var subCategoryIndex = this.getIndexOfK(this.selectedCategory.attributes.sub_categories, params.sub_category, 'code', false);
          this.selectedSubCategoryIndex = subCategoryIndex + 1;
          this.selectedSubCategory = this.selectedCategory.attributes.sub_categories[this.selectedSubCategoryIndex - 1];
          this.currentPage = 1;
          // this.arraymove(this.selectedCategory.attributes.sub_categories,subCategoryIndex,0)
        }

      }
      this.getMerchants();
    })
  }
  arraymove(arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }
  getIndexOfK(arr, value, key, attributes = true) {
    for (var i = 0; i < arr.length; i++) {
      var index = -2;
      if (attributes) {
        if (arr[i].attributes[key] === value) {
          index = i
        }
      }
      else {
        if (arr[i][key] === value) {
          index = i
        }
      }

      if (index > -1) {
        return i;
      }
    }
  }
  merchants: any;
  is_loading: boolean = true;

  getMerchants() {
    this.is_loading = true;
    var params;
    if (this.selectedSubCategory) {
      params = {
        sub_categories: this.selectedSubCategory.parent_id + ":" + this.selectedSubCategory.code,
        per_page: this.perPage,
        page: this.currentPage,
      }
    }
    else if (this.selectedCategory) {
      params = {
        categories: this.selectedCategory.attributes.code,
        per_page: this.perPage,
        page: this.currentPage,
      }
    }

    this.loadMerchants(params);
  }
  loadMerchants(params){
    this._apiService.getMerchants(params).subscribe(
      (res: any) => {
        this.merchants = res.data;
        if(!res.data || res.data.length == 0){

        }
        if (res.meta) {
          this.pagination(res.meta.total_entries, res.meta.per_page);
        }
        this.is_loading = false;
      },
      () => {
      }
    );
  }
  //pagination logic

  totalPages: number = 0;
  currentPage: number = 1;
  perPage: number = 18;
  pageNumStart: number = 0;
  pageNumEnd: number = 5;
  totalPageNumbers: any;
  pagination(offers_count, per_page_count?) {

    if (per_page_count) { this.perPage = per_page_count; }
    this.totalPages = Math.ceil(offers_count / this.perPage);
    if (this.totalPages > 0) {
      this.totalPageNumbers = Array(this.totalPages).fill(0).map((x, i) => i);
      this.paginationLogic(this.currentPage);
    }
  }
  paginationLogic(i) {

    this.currentPage = i;
    if (this.currentPage == this.totalPages) {
      this.pageNumStart = this.currentPage - 5;

    }
    else if (i + 3 > this.totalPages) {
      this.pageNumStart = this.currentPage - 4;
    }
    else if (i - 2 > 0) {
      this.pageNumStart = this.currentPage - 3;
    }
    else if (i - 1 > 0) {
      this.pageNumStart = this.currentPage - 2;
    }
    else {
      this.pageNumStart = this.currentPage - 1;
    }
    if (this.pageNumStart < 0) {
      this.pageNumStart = 0;
    }
    this.pageNumEnd = this.pageNumStart + 5;
  }
  pageClicked(i) {
    if (i <= this.totalPages && i > 0) {
      this.paginationLogic(i);
      this.getMerchants();
      this.scrollElementInView('top-section')
    }
  }
  scrollElementInView(id) {
    setTimeout(() => {
      document.querySelector('#' + id).scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 300)
  }
  backToListing() {
    history.back();
  }
}
